
class CapEditStudent {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return false
  }
}

function key() {
  return 'edit_student'
}

function create(config) {
  return new CapEditStudent(config)
}

export default {
  key,
  create,
}
